<template lang="pug">
  .col-12.mb-4
    v-row(no-gutters)
      .col-3
        v-text-field.ma-0.pa-0(ref="searchField" background-color="#505254" :height="$style.searchHeight" color="#C4C4C4" placeholder="Поиск" rounded hide-details @input="changeHandler" :value="searchValue" @focus="onFocus" @blur="onBlur")
          template(slot="append")
            v-icon.mr-n3(:color="$style.color" :size="$style.searchIconSize") {{ $vuetify.icons.values.search }}

      .col-4.offset-1
        app-appear-animation
          .header-title.text-center
            slot

      .col-4.text-right.text-no-wrap(v-if="showUser")
        .d-inline-block.header-judge__name(v-if="fullname" @click="pwd()") {{ fullname }}
        v-progress-circular(v-else color="#C4C4C4" size="24" width="2" indeterminate)
        v-btn.ml-3.px-0(rounded text clear @click="logout()")
          v-icon(size="24" color="#C4C4C4") exit_to_app
    div(v-if="getUserUuid()")
      changePswdUser(v-model="dialog.changePassword" :userId="getUserUuid()")

</template>

<script>
import { mapGetters } from "vuex";
import { userService } from "@/_services";
import changePswdUser from "@/pages/admin/users/components/changePswdUser";

export default {
  name: "app-page-header",

  props: {
    showUser: {
      type: Boolean,
      default: true
    },
    searchValue: {
      type: String,
      default: ""
    }
  },

  components: {
    changePswdUser
  },

  mounted () {
    window.addEventListener('keydown', this.focusHandler, true)
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.focusHandler, true)
  },

  computed: {
    ...mapGetters("me", ["fullname"])
  },

  methods: {
    focusHandler (event) {
      let codes = [113]
      if (!this.isFocused && codes.includes(+event.keyCode)) {
        this.focusOnSearch()
        event.preventDefault()
        event.stopPropagation()
      }
    },

    focusOnSearch () {
      this.$refs.searchField.focus()
    },

    onFocus () {
      this.isFocused = true
    },

    onBlur () {
      this.isFocused = false
    },

    logout() {
      userService.logout();
    },

    pwd() {
      if (!(window.settings.limitMenu && window.settings.limitMenu.available==true && window.settings.limitMenu.key== 'gsu')) 
        this.dialog.changePassword = true
    },

    getUserUuid() {
      let uuid = localStorage.getItem("useruuid");
      return uuid ? uuid.slice(1, uuid.length - 1) : null;
    },

    changeHandler(text) {
      this.$emit("search", text);
    }
  },
  data() {
    return {
      dialog: {
        changePassword: false
      },
      isFocused: false
    };
  }
};
</script>

<style lang="scss" module>
$app-header-search-height: 28;

:export {
  color: #c4c4c4;
  searchHeight: $app-header-search-height;
  searchIconSize: $app-header-search-height - 8;
}
</style>

<style lang="scss" scoped>
.header-title {
  font: $app-header-title-font;
  color: $app-header-title-color;
}
.header-judge__name {
  font: $app-header-judge-font;
  color: $app-header-judge-color;
  cursor: pointer;
}
</style>
